import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/core/hooks/useAuth";
import { fetchPlans } from "@/core/api/billingApi";

/**
 * Catálogo de planos visíveis (nome, preços mensal/anual, limites e flags de
 * feature) mais o bloco `promo` do cupom da conta, para a tela de seleção de
 * plano. Compartilhado entre o gate de onboarding e o paywall.
 *
 * `sectorId` escopa de qual conta sai o cupom (o backend resolve a Company pelo
 * acesso daquele setor). Entra na queryKey porque duas contas do mesmo usuário
 * podem ter cupons diferentes.
 *
 * `enabled` (padrão true): o bloqueio por plano só pede o catálogo quando há
 * recurso fora do plano, para trial e planos completos não baixarem à toa.
 */
export function usePlansCatalog(
  sectorId?: string | null,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["billing", "plans", sectorId ?? "__any__"],
    queryFn: () => fetchPlans(token, sectorId),
    staleTime: 5 * 60_000,
    enabled,
  });
}
